import React from 'react';
import PropTypes from 'prop-types';
import s from './ModelCategory.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import moment from 'moment-timezone';
import MoreOption from '../WSAControls/MoreOption/MoreOption';
import { ModelCategoryPermission } from '../../constants';
import { getModelCategoryPermission } from '../../utils';

const ModelCategoryListTable = ({ paginatedData = [], UpdateAllowed, DuplicateAllowed, ConfigurationAllowed, UserModelCategories, currentTimezone }) => {
  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelcategory.ModelCategoryName" defaultMessage="Model Category Name" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelcategory.description" defaultMessage="Description" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelcategory.dateCreated" defaultMessage="Date created" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelcategory.dateModified" defaultMessage="Date modified" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            let isOwner = getModelCategoryPermission(UserModelCategories, n.ModelCategoryId, ModelCategoryPermission.Owner)
            return (
              <tr key={n.ModelCategoryId} data-unittest="modelData">
                <td>{n.Name || ''}</td>
                <td className="d-none d-md-table-cell">{n.Description || ''}</td>
                <td className="d-none d-md-table-cell">
                  {n.CreatedDateTime
                    ? moment
                      .unix(n.CreatedDateTime)
                      .tz(currentTimezone)
                      .format('DD-MMM-YYYY')
                    : '-'}
                </td>
                <td className="d-none d-md-table-cell">
                  {n.ModifiedDateTime
                    ? moment
                      .unix(n.ModifiedDateTime)
                      .tz(currentTimezone)
                      .format('DD-MMM-YYYY')
                    : '-'}
                </td>
                <td>
                  <MoreOption
                    dataArray={[
                      UpdateAllowed && isOwner
                        ? {
                          Url: `/operational-setup/model-category/${n.ModelCategoryId}`,
                          Name: <FormattedMessage id="modelcategory.edit" defaultMessage="Edit" />
                        }
                        : {},
                      ConfigurationAllowed
                        ? {
                          Url: `/operational-setup/model-category-configuration/${n.ModelCategoryId}/`,
                          Name: <FormattedMessage id="modelcategory.configuration" defaultMessage="Configuration" />
                        }
                        : {},

                      // DuplicateAllowed
                      //   ? {
                      //       Url: `//operational-setup/model-category/${n.ModelCategoryId}/true`,
                      //       Name: <FormattedMessage id="modelcategory.duplicate" defaultMessage="Duplicate" />
                      //     }
                      //   : {}
                      // { Url: `#`, Name: <FormattedMessage id="model.delete" defaultMessage="Delete" /> }
                    ]}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

ModelCategoryListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ModelCategoryListTable);
